import React, { useEffect } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import moment from 'moment';

import TitleBar from '../../titleBar/titleBar';
import AgGridTable from '../../agGridComponent/agGridTable';
import LoadingPlaceholder from '../../placeholder/loadingPlaceholder'

import BranchActionButton from './branchActionButton';

import { getBranch, updateBranch, deleteBranch } from '../../../redux/actions/branchMasterActions';
import { HEADERS } from './branchConstants'
import { DATE_FORMATS } from '../../../config/const'
import { FEATURES } from '../../../config/features';

function BranchTable(props) {

    const { branchData, branchLoading, getBranch, updateBranch, deleteBranch } = props;

    const customerNumber = localStorage.getItem("customerNo")

    useEffect(() => {
        getBranch()
    }, [getBranch]);


    if (branchLoading) {
        return (
            <React.Fragment>
                <TitleBar title="Branch" LinkName="" />
                <LoadingPlaceholder />
            </React.Fragment>
        )

    } else {

        let columnDefs = [
            { headerName: HEADERS.branch_code || 'Code', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.branch_name || 'Branch Name', field: 'branchName', tooltipField: 'branchName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.address || 'Address', field: 'address', tooltipField: 'address', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.pincode || 'Pincode', field: 'pincode', tooltipField: 'pincode', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.service_category || 'Service Category', field: 'serviceCategory', tooltipField: 'serviceCategory', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.cost_center || 'Cost Center', field: 'costCenter', tooltipField: 'costCenter', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.created_by || 'Created By', field: 'createdByUserName', tooltipField: 'createdByUserName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.created_on || 'Last Create Date', field: 'lastCreatedDate', tooltipField: 'lastCreatedDate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.updated_by || 'Updated By', field: 'updatedByUserName', tooltipField: 'updatedByUserName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.updated_on || 'Updated Date', field: 'updatedDate', tooltipField: 'updatedDate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.actions || 'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer',pinned: 'right', width: 280, suppressToolPanel: true }
        ]

        let frameworkComponents = {
            actionRenderer: BranchActionButton,
        }

        let rowData = []

        branchData && branchData.forEach((object, index) => {
            let temp = {}
            temp.code = object.branchCode
            temp.branchName = object.branchName
            temp.branchId = object.branchId
            temp.address = object.address
            temp.pincode = object.pincode
            temp.panNo = object.panNo
            temp.cityId = object.cityId
            temp.cityName = object.cityName
            temp.stateName = object.stateName
            temp.stateId = object.stateId
            temp.createdBy = object.createdBy
            temp.createdByUserName = object.createdByUserName
            temp.lastCreatedDate = moment(object.createdOn).format(DATE_FORMATS.DD_MM_YYYY)
            temp.updatedBy = object.updatedBy
            temp.updatedByUserName = object.updatedByUserName
            temp.updatedDate = object?.updatedOn ? moment(object.updatedOn).format(DATE_FORMATS.DD_MM_YYYY) : ''
            temp.updateBranch = updateBranch
            temp.deleteBranch = deleteBranch
            temp.isGSTApplicable = object.isGSTApplicable
            temp.gstNo = object.gstNo
            temp.GSTExemptedReasonId = object.GSTExemptedReasonId
            temp.isGSTExempted = object.isGSTExempted
            temp.validityStartDate = object.validityStartDate
            temp.validityEndDate = object.validatityEndDate
            temp.gstChargeMechanism = object.gstChargeMechanism
            temp.serviceCategory = object.serviceCategory
            temp.serviceCategoryId = object.serviceCategoryId
            temp.costCenter = object.costCenter
            rowData[index] = temp
        })


        return (
            <React.Fragment>
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    link="#"
                    baseUrl={props}
                    //hiddenNew={true}
                    newPopup={props.newPopup}
                    hiddenImportPopupBtn={true}
                    extraComponents={frameworkComponents}
                    titleBarTitle="Branch"
                    handleSearch={props.handleSearch}
                    showImport={true}
                    fileName='branchMaster'
                    path='branchMaster'
                    disableFilter={true} 
                    master={true}
                    newModalFunction={props.openAddModal}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
        )
    }
}


const mapStatetoProps = (state) => ({
    branchData: state.getBranchData.branch.resultSet,
    branchLoading: state.getBranchData.isLoading
})

export default connect(mapStatetoProps, { getBranch, updateBranch, deleteBranch })(BranchTable)